import React, { FC, useEffect, useState } from 'react'
import { Card, Typography, Image, List, Badge, Empty } from 'antd'
import { LikeTwoTone } from '@ant-design/icons'

export const RecentTopics: FC = () => {
  const [topics, setTopics] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(true)

  // Fetch recent topics from Discourse
  // It works once app is deployed, but not in local dev mode due to CORS issues
  async function getData() {
    const url =
      'https://discourse.pollination.solutions/c/announcements/10.json?ascending=false'
    try {
      setLoading(true)
      const response = await fetch(url, {
        mode: 'cors',
      })

      if (!response.ok) {
        setTopics([])
      }

      const topics = await response.json()

      setTopics(
        topics.topic_list.topics
          ?.filter((t: any) => !t.archived && t.id !== 22)
          ?.slice(0, 6) ?? []
      )
    } catch (error: any) {
      console.error(error.message)
      setTopics([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getData()
  }, [])

  return (!topics || topics.length === 0) ? null : (
    <List
      grid={
        {
          gutter: 20,
          xs: 2,
          sm: 2,
          md: 3,
          lg: 3,
          xl: 3,
          xxl: 3,
        }
      }
      dataSource={topics ?? []}
      renderItem={({ id, slug, title, image_url, like_count }) => (
      <List.Item key={id}>
        <Typography.Link target='_blank' href={`https://discourse.pollination.solutions/t/${slug}/${id}`}>
        <Badge.Ribbon style={{ height: 26 }} text={<span>
          {like_count}
          <LikeTwoTone style={{ fontSize: 20 }} />
        </span>}>
        <Card
          hoverable
          cover={<>
            {image_url ? <img
              style={{
                height: 180,
                objectFit: 'cover'
              }}
              alt={title}
              src={image_url}
            /> : <Image
              style={{
                height: 140,
                objectFit: 'fill'
              }}
              preview={false}
              src='/brandmark.svg'
            />}
          </>}
        >
          <Typography.Text>{title}</Typography.Text>
        </Card>
        </Badge.Ribbon></Typography.Link>
      </List.Item>)}
      locale={{
        emptyText: <Empty description={
          <Typography.Text>
            No news here...
          </Typography.Text>
        } />
      }}
      loading={loading}
      pagination={false}
    />
  )
}
